<template>
  <div id="dclines">
    <div class="container grid-lg mb-2 p-0" aria-labelledby="header-title">
      <Header title="DC Lines"></Header>

      <header id="subheader" class="navbar">
        <section class="navbar-section">
          <nav aria-label="Breadcrumb">
            <ul class="breadcrumb px-2">
              <li class="breadcrumb-item">
                <router-link to="/">Case</router-link>
              </li>
              <li class="breadcrumb-item" aria-current="page">DC Lines</li>
            </ul>
          </nav>
        </section>
        <section class="navbar-section">
          <HelpButton section="dclinedataTable" />
          <div v-if="hasLines" class="form-group">
            <select
              v-model="table"
              class="form-select select-sm"
              aria-label="Table view"
            >
              <option value="initial">Initial</option>
              <option value="pf">Power Flow</option>
              <option value="opf">OPF</option>
            </select>
          </div>
        </section>
      </header>

      <DCLineTable v-if="hasLines && table === 'initial'" />
      <DCLinePFTable v-if="hasLines && table === 'pf'" />
      <DCLinePFTable v-if="hasLines && table === 'opf'" opf="true" />

      <div v-if="!hasLines" class="empty">
        <div class="empty-icon">
          <plus-square-icon />
        </div>
        <p class="empty-title h5">This case does not contain any DC Lines</p>
        <p class="empty-subtitle">Click the button to add a DC Line.</p>
        <div class="empty-action">
          <button v-on:click="addLine" class="btn btn-primary">
            Add DC Line
          </button>
        </div>
      </div>
    </div>
    <button
      v-if="hasLines"
      v-on:click="addLine"
      id="fab"
      class="btn btn-action btn-lg btn-primary s-circle tooltip tooltip-left"
      data-tooltip="Add DC Line"
      aria-label="Add DC Line"
    >
      <plus-icon />
    </button>
  </div>
</template>

<script>
import { PlusIcon, PlusSquareIcon } from "vue-feather-icons";

import Header from "../components/Header";
import HelpButton from "../components/HelpButton";
import DCLineTable from "../components/dcline/DCLineTable";
import DCLinePFTable from "../components/dcline/DCLinePFTable";
import MPCStore from "../stores/MPCStore";

export default {
  name: "DCLines",
  data() {
    return {
      table: "initial"
    };
  },
  computed: {
    hasLines() {
      return MPCStore.methods.getDCLines().length !== 0;
    }
  },
  methods: {
    addLine() {
      let idx = MPCStore.methods.addDCLine();
      this.$router.push({ name: "dcline", params: { ord: idx + 1 } });
    }
  },
  components: {
    Header,
    HelpButton,
    DCLineTable,
    DCLinePFTable,
    PlusIcon,
    PlusSquareIcon
  }
};
</script>

<style lang="scss" scoped>
#dclines {
  min-height: 100vh;
}

#fab {
  position: fixed;
  right: 5vh;
  bottom: 5vh;
}
</style>
